var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 73.104,
    viewBox: "0 0 62 73.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 62,
    height: 73,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 14.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M42.767,72.546H18.943A18.59,18.59,0,0,1,.375,53.978V18.943A18.59,18.59,0,0,1,18.943.375H42.767A18.59,18.59,0,0,1,61.335,18.943V53.978A18.59,18.59,0,0,1,42.767,72.546M18.943,5.28A13.679,13.679,0,0,0,5.28,18.943V53.978A13.679,13.679,0,0,0,18.943,67.642H42.767A13.679,13.679,0,0,0,56.43,53.978V18.943A13.679,13.679,0,0,0,42.767,5.28Z",
    transform: "translate(-0.025 -0.025)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M47.137,54.308h-9.81a2.452,2.452,0,0,1,0-4.9h9.81a2.452,2.452,0,0,1,0,4.9m0-14.014h-9.81a2.452,2.452,0,0,1,0-4.9h9.81a2.452,2.452,0,0,1,0,4.9m0-14.014h-9.81a2.452,2.452,0,0,1,0-4.9h9.81a2.452,2.452,0,0,1,0,4.9",
    transform: "translate(-2.293 -1.405)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M20.354,55.158a5.239,5.239,0,0,1-3.617-1.444l-.593-.561a2.452,2.452,0,1,1,3.367-3.566l.6.566a.352.352,0,0,0,.482,0l3.258-3.081a2.452,2.452,0,1,1,3.371,3.561l-3.255,3.08a5.234,5.234,0,0,1-3.612,1.442m0-14.014A5.239,5.239,0,0,1,16.737,39.7l-.594-.561a2.453,2.453,0,1,1,3.369-3.565l.6.566a.347.347,0,0,0,.481,0L23.85,33.06a2.453,2.453,0,0,1,3.371,3.563L23.965,39.7a5.234,5.234,0,0,1-3.612,1.442m0-14.014a5.235,5.235,0,0,1-3.617-1.444l-.594-.561a2.453,2.453,0,1,1,3.369-3.565l.6.566a.346.346,0,0,0,.481,0l3.258-3.082a2.453,2.453,0,1,1,3.371,3.563l-3.255,3.08a5.233,5.233,0,0,1-3.612,1.441",
    transform: "translate(-1.011 -1.208)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon11);
export default __webpack_public_path__ + "static/media/social_icon11.19217d8838242277f79d2d62ad6d7c64.svg";
export { ForwardRef as ReactComponent };